import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ConfigContainer from './containers/config';
import StatusContainer from './containers/status';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.css';

const container = document.getElementById('app');
const root = createRoot(container!);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ConfigContainer />} />
        <Route path="/status" element={<StatusContainer />} />
      </Routes>
    </BrowserRouter>
  );
}

root.render(<App />);
